import { env } from 'src/config/env'

const isDev = env.MODE !== 'prod'

export const logger = {
  debug: (...args: any[]) => {
    if (isDev) {
      console.log(...args)
    }
  },
  warn: (...args: any[]) => {
    console.warn(...args)
  },
  error: (...args: any[]) => {
    console.error(...args)
  },
}
